import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { ListDTO } from 'src/registry/types/queries';
import { formatResourcePath } from 'src/utils/regex';
import { ListResponseAPI } from 'src/lib/queries';
import { Role } from 'src/features/roles/utils/types';

const RESOURCE = '/users/role/';

type QueryFnType = typeof queryFn;
const queryFn = (params: ListDTO): Promise<ListResponseAPI<Role>> => {
    return axios.get(formatResourcePath(RESOURCE), { params });
};

interface UseQueryHookOptions extends ListDTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        staleTime: 1000 * 60 * 30,
        ...config,
    });

export { RESOURCE as LIST_ROLES_RESOURCE, useQueryHook as useListRoles };
